import { render, staticRenderFns } from "./EMobilityDetailsPage.vue?vue&type=template&id=54d0e768&scoped=true"
import script from "./EMobilityDetailsPage.vue?vue&type=script&lang=js"
export * from "./EMobilityDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./EMobilityDetailsPage.vue?vue&type=style&index=0&id=54d0e768&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54d0e768",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VAlert,VBtn,VIcon,VProgressCircular})
